// Utils
// Types
import type { GetStaticProps, NextPage } from 'next'
// Components
import Head from 'next/head'
import type { FC } from 'react'

import ProjectHeader from '../../components/molecules/projects/ProjectHeader'
import { Post } from '../../types/hashnode'
// Content
import { getPost } from '../../utils/hashnode'

interface Props {
    contractAddress: string
    article: Post
}

const MiniDegens: FC<Props> = ({ article }) => {
    return (
        <article className="prose mx-auto max-w-2xl dark:prose-invert">
            <ProjectHeader
                title="Pixelaro"
                category="Multiplataforma"
                logo="/images/projects/logo.png"
                tags={['Flutter', 'Dart', 'Impeller', 'Skia']}
                url="https://github.com/JairRodrigue/pixelaro"
            />

            <p>
                O Pixelaro é um editor de imagens profissional projetado para ser leve e
                acessível em qualquer dispositivo. Construído com a tecnologia Flutter e
                engine Impeller/Skia, ele garante alta performance e fluidez. O
                aplicativo suporta Web, Linux (via Snap Store) e Android, oferecendo um
                conjunto completo de ferramentas como cortes, rotação, filtros avançados
                (Aden, Amaro, Lark), desenho livre e adição de stickers, tudo com
                processamento local para garantir a privacidade do usuário.
            </p>

            <h3>Links</h3>

            <ul>
                <li>
                    <a
                        href="https://github.com/JairRodrigue/pixelaro"
                        target={'_blank'}
                        rel="noopener noreferrer"
                    >
                        GitHub
                    </a>
                </li>
                <li>
                    <a
                        href="https://github.com/JairRodrigue/pixelaro/releases"
                        target={'_blank'}
                        rel="noopener noreferrer"
                    >
                        Releases
                    </a>
                </li>
            </ul>

            <a
                className="not-prose my-4 inline-block"
                href="https://jairrodrigue.github.io/pixelaro/"
                title="View on PyPI"
                target="_blank"
                rel="noreferrer"
            >
                <div className="flex w-[220px] items-center gap-3 rounded-lg border bg-white px-4 py-3 shadow-lg">
                    <img
                        src="https://images.vexels.com/media/users/3/205566/isolated/preview/c65f9eac24be62dfdcc5f509a32930f8-traco-do-icone-do-site.png"
                        alt="PyPI"
                        className="size-8 object-contain"
                    />

                    <div className="leading-tight">
                        <div className="text-xs font-medium text-gray-500">Ver Online</div>
                        <div
                            className="text-lg font-extrabold tracking-tight text-gray-900"
                            style={{ fontFamily: '"Source Sans Pro", system-ui, sans-serif' }}
                        >
                            Pixelaro Studio
                        </div>
                    </div>
                </div>
            </a>
        </article>
    )
}

const MiniDegensPage: NextPage<Props> = (props) => (
    <div className="container mx-auto">
        <Head>
            <title>Pixelaro</title>
        </Head>

        <MiniDegens {...props} />
    </div>
)

export default MiniDegensPage

export const getStaticProps: GetStaticProps<Props> = async () => {
    return {
        props: {
            contractAddress: '0x24F6328cdDDdad9475c9a3DC2675b5ef851A7C5E',
            article: await getPost('6968db8b1065d3643b0c86fe'),
        },
    }
}
